import { useEffect, useMemo, useState } from 'react';
import { apiRequest } from './client';

export function useSupplierSearch(productType, criteria, enabled = true) {
  const criteriaJson = useMemo(() => JSON.stringify(criteria), [criteria]);
  const request = useMemo(() => ({
    currency: 'INR',
    criteria: JSON.parse(criteriaJson),
  }), [criteriaJson]);
  const [result, setResult] = useState({ loading: true, offers: [], suppliersWithErrors: [], error: null });

  useEffect(() => {
    if (!enabled) {
      setResult({ loading: false, offers: [], suppliersWithErrors: [], error: null });
      return undefined;
    }

    const controller = new AbortController();
    setResult({ loading: true, offers: [], suppliersWithErrors: [], error: null });
    const path = productType === 'Flight' ? '/api/flights/search' : '/api/search';
    const body = productType === 'Flight' ? request : { productType, ...request };
    apiRequest(path, { body, signal: controller.signal })
      .then((response) => setResult({
        loading: false,
        offers: response.offers || [],
        suppliersWithErrors: response.suppliersWithErrors || [],
        error: null,
      }))
      .catch((error) => {
        if (error.name !== 'AbortError') {
          setResult({ loading: false, offers: [], suppliersWithErrors: [], error });
        }
      });

    return () => controller.abort();
  }, [enabled, productType, request]);

  return result;
}
